















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RecipeList extends Vue {
    private role!: string | null;

    private data() {
        return {
            role: '',
        };
    }

    private created() {
        this.role = localStorage.getItem('role');
    }
}
